'use client';

import { HeroUIProvider, ToastProvider } from '@heroui/react';

export default function GlobalProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  // `aria` keeps browser constraint validation (e.g. type='email') from
  // blocking submit before react-hook-form can surface its own messages.
  return (
    <HeroUIProvider className='h-full' validationBehavior='aria'>
      <ToastProvider
        placement='bottom-center'
        toastProps={{
          // radius: "full",
          color: 'success',
          variant: 'flat',
          timeout: 4000,
          // hideIcon: true,
          // classNames: {
          //   closeButton: "opacity-100 absolute right-4 top-1/2 -translate-y-1/2",
          // },
          shouldShowTimeoutProgress: true,
        }}
      />
      {children}
    </HeroUIProvider>
  );
}
